import { login_phone } from '@/api';
export default {
  name: "login-phone-no",

  data() {
    return {
      form: {
        phone_area_code: "852",
        phone: "",
        password: ""
      },
      rules: {
        phone: [{
          required: true,
          message: this.$t("Please fill in phone number"),
          trigger: "blur"
        }, {
          type: 'number',
          message: this.$t("Please fill in only number")
        }]
      },
      widgetID: null
    };
  },

  created() {//if dev mode , fill in the form

    /* if (process.env.NODE_ENV === "development") {
      this.form.phone = 36661580;
      this.form.password = "Kck12345";
    } */
  },

  mounted() {
    this.widgetID = window.hcaptcha.render('hcaptcha', {
      sitekey: '05368fc8-382e-41aa-acdc-bec02e6acbf2'
    });
  },

  methods: {
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        /*  const respKey = window.hcaptcha.getResponse(this.widgetID);
         if (!respKey) {
           return;
         } */
        if (valid) {
          this.$emit("showErr", false);
          let {
            data
          } = await login_phone(this.form.phone_area_code, this.form.phone + '', this.form.password);

          if (data.message == "OK") {
            this.$message("Login successfully", {
              type: 'success'
            });

            if (process.env.NODE_ENV !== "development") {
              window.self.location.href = "https://overlander.com.hk/";
            }
          } else {
            this.$emit('showErr', data.message);
          }

          return;
        }
      });
    }

  }
};